import { PoolEntity } from "@/entities/PoolEntity.js";
import { apiRequest } from "@/services/api/apiClient.js";

const entity = new PoolEntity();
export async function getPools({ page = 1, limit = 10, ...filters } = {}) {
    return apiRequest({
        client: window.API_ISP,
        method: "get",
        url: entity.endpoints.list,
        params: { page, limit, ...filters },
    });
}

export async function getPoolById({id}) {
    return apiRequest({
        client: window.API_ISP,
        method: "get",
        url: entity.getUrl(entity.endpoints.get, { id }),
    });
}

export async function createPool(data) {
    return apiRequest({
        client: window.API_ISP,
        method: "post",
        url: entity.endpoints.create,
        body: data,
    });
}

export async function savePool(data) {
    const isUpdate = !!data.id;
    let url = isUpdate
        ? entity.getUrl(entity.endpoints.get, { id: data.id })
        : entity.endpoints.create;

    const response = apiRequest({
        client: window.API_ISP,
        method: isUpdate ? "put" : "post",
        url,
        body: data,
    });

    if(response.status !== data.status && isUpdate) {
        const statusChange = data.status ? 'activate' : 'deactivate';
        let urlStatusChange = entity.getUrl(entity.endpoints[statusChange], { id: data.id });

        await apiRequest({
            client: window.API_ISP,
            method: "put",
            url: urlStatusChange,
            body: {
                name
            },
        });
    }

    return response;
}

export async function deletePool({id}) {
    const url = entity.getUrl(entity.endpoints.delete, { id });
    return apiRequest({
        client: window.API_ISP,
        method: "delete",
        url,
    });
}
